(ns storrito.instagram-connect.account-sync
  (:require [app.util.api-request :as api]
            ))

(defn request-sync!
  [{:keys [ig-user-id manually-sync] :or {manually-sync false}}]
  (api/request {:request-method :post
                :url "/api/instagram-info"
                :transit-params {:ig-user-id ig-user-id
                                 :manually-sync manually-sync}}))
